import { Button } from "@mui/material"
import { useState } from "react"
import { getFeeFilters, getFeeSort, getProgramStats } from "../../api"

import AddFee from "../modals/AddFee"
import ListData from "../common/ListData"
import FeePayCard from "../cards/FeePaymentCard"
import { useParams } from "react-router-dom"

const ProgramFeePayments = ({ setProgram }) => {
  const { programId } = useParams()
  const [addFeeModal, setAddFeeModal] = useState(false)

  const openAddFee = () => setAddFeeModal(true)
  const closeAddFee = () => setAddFeeModal(false)

  const CTA = () => (
    <Button variant="contained" onClick={openAddFee}>
      Add Fee Payment
    </Button>
  )

  return (
    <>
      <ListData
        getFilters={getFeeFilters}
        getSort={getFeeSort}
        getAllData={getProgramStats}
        getDataBody={{ programId: programId }}
        dataKey="student"
        initialFilters={{}}
        HeaderRight={CTA}
        Card={FeePayCard}
      />
      <AddFee isOpen={addFeeModal} close={closeAddFee} />
    </>
  )
}

export default ProgramFeePayments
